import { testimonials } from '@/mocks/testimonials';

const avatarColors = [
  'bg-accent-100 text-accent-700',
  'bg-secondary-100 text-secondary-700',
  'bg-amber-100 text-amber-700',
  'bg-emerald-100 text-emerald-700',
  'bg-rose-100 text-rose-700',
  'bg-teal-100 text-teal-700',
];

export default function TestimonialsSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="mb-10">
          <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-semibold rounded-full mb-4">
            Community Reviews
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">
            Hear From <br />Our Shoppers
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {[0, 1, 2].map((colIdx) => (
            <div key={colIdx} className="flex flex-col gap-5">
              {testimonials
                .filter((_, i) => i % 3 === colIdx)
                .map((t, idx) => (
                  <div
                    key={t.id}
                    className="bg-white rounded-xl p-5 border border-background-200"
                  >
                    <div className="flex items-center gap-3 mb-3">
                      <div className={`w-10 h-10 rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0 ${avatarColors[(t.id - 1) % avatarColors.length]}`}>
                        {t.avatar}
                      </div>
                      <div>
                        <p className="text-sm font-semibold text-foreground-800">{t.name}</p>
                        <p className="text-xs text-foreground-400">{t.username}</p>
                      </div>
                    </div>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      &ldquo;{t.content}&rdquo;
                    </p>
                  </div>
                ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}